/**
 * Normaliza lo que el usuario pega en el buscador público de verificación.
 *
 * Acepta tanto el ID suelto como la URL completa que viaja en el QR del PDF
 * estampado (`https://v3.tufirma.digital/documents/<id>`, con o sin prefijo de
 * locale, query o hash), porque en la práctica la gente pega el enlace entero.
 *
 * No exige UUID: los documentos migrados desde la v2 conservan ids con otro
 * formato (`id_old`), así que solo descartamos lo que no puede ser un id y
 * dejamos que el backend responda si existe o no.
 */
const DOCUMENT_ID_PATTERN = /^[a-zA-Z0-9_-]{8,64}$/;

export const parseDocumentId = (rawValue: string): string | null => {
  const trimmed = rawValue.trim();

  if (!trimmed) {
    return null;
  }

  const withoutQuery = trimmed.split(/[?#]/)[0];

  let candidate = withoutQuery;

  if (withoutQuery.includes('/')) {
    const segments = withoutQuery.split('/').filter(Boolean);
    // En una URL el id viaja justo después del segmento `documents`; buscarlo
    // así evita quedarse con `documents` cuando pegan el enlace sin el id.
    const marker = segments.lastIndexOf('documents');
    candidate = (marker >= 0 ? segments[marker + 1] : segments[segments.length - 1]) ?? '';
  }

  return DOCUMENT_ID_PATTERN.test(candidate) ? candidate : null;
};
